import { css, useTheme } from '@emotion/react';

import { fontSizes, spacing } from '@/theme/tokens';

type PipelineStatus = 'draft' | 'needs_analysis' | 'needs_rehearsal' | 'needs_music' | 'ready';

interface MusicStatusBadgeProps {
  status: PipelineStatus;
}

const STATUS_CONFIG: Record<PipelineStatus, { label: string; colorKey: string }> = {
  draft: { label: 'Draft', colorKey: 'muted' },
  needs_analysis: { label: 'Needs Analysis', colorKey: 'info' },
  needs_rehearsal: { label: 'Needs Rehearsal', colorKey: 'info' },
  needs_music: { label: 'Needs Music', colorKey: 'warning' },
  ready: { label: 'Ready to Present', colorKey: 'success' },
};

export function MusicStatusBadge({ status }: MusicStatusBadgeProps) {
  const theme = useTheme();
  const config = STATUS_CONFIG[status];

  const colorMap: Record<string, { bg: string; fg: string }> = {
    muted: { bg: theme.colors.surface, fg: theme.colors.textMuted },
    info: { bg: theme.colors.infoMuted, fg: theme.colors.info },
    warning: { bg: theme.colors.warningMuted, fg: theme.colors.warning },
    success: { bg: theme.colors.successMuted, fg: theme.colors.success },
  };

  const colors = colorMap[config.colorKey];

  return (
    <span
      css={css`
        display: inline-flex;
        align-items: center;
        font-size: ${fontSizes.xs};
        padding: 2px ${spacing.sm};
        border-radius: 12px;
        background: ${colors.bg};
        color: ${colors.fg};
        font-weight: ${config.colorKey === 'success' ? 600 : 500};
        white-space: nowrap;
      `}
    >
      {config.label}
    </span>
  );
}
